import { render, staticRenderFns } from "./AttachmentManager.vue?vue&type=template&id=f0b6a530&scoped=true&"
import script from "./AttachmentManager.vue?vue&type=script&lang=js&"
export * from "./AttachmentManager.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentManager.vue?vue&type=style&index=0&id=f0b6a530&prod&scoped=true&lang=css&"
import style1 from "./AttachmentManager.vue?vue&type=style&index=1&id=f0b6a530&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b6a530",
  null
  
)

export default component.exports